// tslint:disable
/**
 * Course API
 * Used for: - Manage courses - Manage course info - Manage students - Learning control 
 *
 * The version of the OpenAPI document: 2.6.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Course } from './course';
import { Student } from './student';

/**
 * 
 * @export
 * @interface Registration
 */
export interface Registration {
    /**
     * 
     * @type {string}
     * @memberof Registration
     */
    id: string;
    /**
     * 
     * @type {Student}
     * @memberof Registration
     */
    student: Student;
    /**
     * 
     * @type {string}
     * @memberof Registration
     */
    studentId: string;
    /**
     * 
     * @type {Course}
     * @memberof Registration
     */
    course: Course;
    /**
     * 
     * @type {string}
     * @memberof Registration
     */
    courseId: string;
    /**
     * Additional metadata
     * @type {object}
     * @memberof Registration
     */
    metadata?: object;
    /**
     * 
     * @type {string}
     * @memberof Registration
     */
    status: RegistrationStatusEnum;
    /**
     * 
     * @type {Date}
     * @memberof Registration
     */
    startedAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof Registration
     */
    finishedAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof Registration
     */
    createdAt: Date;
    /**
     * 
     * @type {boolean}
     * @memberof Registration
     */
    isFinished: boolean;
}

/**
    * @export
    * @enum {string}
    */
export enum RegistrationStatusEnum {
    Learning = 'learning',
    Pause = 'pause',
    Success = 'success',
    Fail = 'fail',
    Abort = 'abort'
}



